import { GET_SYSTEM, CHANGED_SYSTEM_VALUE } from './types'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_SYSTEM:
      return {
        ...state,
        system: action.payload,
      }
    case CHANGED_SYSTEM_VALUE:
      return {
        ...state,
        system: {
          ...state.system,
          [action.payload.divisionId || 15]: { ...state.system[action.payload.divisionId || 15], ...action.payload },
        },
      }
    default:
      return state
  }
}
